import React, { useEffect } from 'react';
import { Loader } from '@/components/custom/loader';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { i18n } from 'src/app/components/i18n/i18n';
import { FormTaxonomy } from '@/components/custom/form';

export default function StepName(props) {
  const { t } = useTranslation();
  const { step, createLessonForm, loading, taxonomies, bodyError, loadingTaxonomies, isOpenModalTaxonomies, setIsOpenModalTaxonomies } = props;
  const { lessonId } = useParams();
  const unrequired = createLessonForm.values.unrequired;

  useEffect(() => {
    i18n.changeLanguage(process.env.REACT_APP_LOCALE);
  }, []);

  return (
    step === 'nome' && (
      <div className="page__content mb-12 animate-fade-in">
        <div className="new-questions__header">
          <h2 className="new-questions__title">
            {loading && <Loader />}
            {!loading && lessonId && createLessonForm.values.body}
            {!loading && !lessonId && createLessonForm.values.body === '' && 'Nova aula'}
            {!loading && !lessonId && createLessonForm.values.body}
          </h2>
        </div>

        <div className="new-questions__body">
          <label className="form__label">{t('lessons.isLessonMandatory')}</label>

          <div className="form__check form__switch">
            <input
              className="form__check-input"
              id={unrequired}
              name={unrequired}
              type="checkbox"
              checked={unrequired}
              onClick={() => {
                createLessonForm.setFieldValue('unrequired', !unrequired);
              }}
            />
            <label> {t('textsCommon.mandatoryLesson')}</label>
          </div>

          <div className="form__row">
            <label
              className="form__label"
              htmlFor="body"
            >
              *{t('textsCommon.lessonName')}
            </label>
            <input
              className="form__control"
              placeholder={t('textsCommon.writeHere')}
              id="body"
              name="body"
              type="text"
              value={createLessonForm.values.body}
              onChange={e => createLessonForm.setFieldValue('body', e.target.value)}
            />
            {bodyError && !createLessonForm.values.body && <span style={{ color: 'red' }}>{bodyError}</span>}
          </div>

          <FormTaxonomy
            label={t('tasks.mattersRelated')}
            isLoading={loadingTaxonomies}
            taxonomies={taxonomies}
            selectedTaxonomies={createLessonForm?.values?.selectedTaxonomies}
            setFieldValue={createLessonForm?.setFieldValue}
            errors={createLessonForm?.errors}
            touched={createLessonForm?.touched}
            isOpenModalTaxonomies={isOpenModalTaxonomies}
            setIsOpenModalTaxonomies={setIsOpenModalTaxonomies}
          />
        </div>
      </div>
    )
  );
}
